import { appMode } from 'src/config'

/**
 * @param {import('@quasar/app-webpack').BootFileParams} params
 */
export default async ({ app }) => {
  const localDb = {}
  let DB

  localDb.getDb = async function (storeName) {
    return new Promise((resolve, reject) => {
      if (DB && DB.name === appMode + storeName) { return resolve(DB) }
      const request = window.indexedDB.open(appMode + storeName, 1)

      request.onerror = e => {
        console.log('Error opening db', e)
        reject('Error')
      }

      request.onsuccess = e => {
        DB = e.target.result
        resolve(DB)
      }

      request.onupgradeneeded = e => {
        const db = e.target.result
        const objectStore = db.createObjectStore(storeName, { keyPath: 'id' })
        objectStore.createIndex('id', 'id', { unique: true })
      }
    })
  }

  localDb.getAll = async function (storeName) {
    const db = await localDb.getDb(storeName)

    return new Promise(resolve => {
      const trans = db.transaction([storeName], 'readonly')
      trans.oncomplete = () => {
        resolve(data)
      }

      const store = trans.objectStore(storeName)
      const data = []

      store.openCursor().onsuccess = e => {
        const cursor = e.target.result
        if (cursor) {
          data.push(cursor.value)
          cursor.continue()
        }
      }
    })
  }

  localDb.getAllKeys = async function (storeName) {
    const db = await localDb.getDb(storeName)
    return new Promise(resolve => {
      const trans = db.transaction(storeName).objectStore(storeName).index('id').getAllKeys()

      trans.onsuccess = e => {
        resolve(e.target.result)
      }
    })
  }

  localDb.delete = async function (storeName, key) {
    const db = await localDb.getDb(storeName)

    return new Promise(resolve => {
      const trans = db.transaction([storeName], 'readwrite')
      trans.oncomplete = () => {
        resolve()
      }

      const store = trans.objectStore(storeName)
      store.delete(key)
    })
  }

  localDb.get = async function (storeName, key) {
    const db = await localDb.getDb(storeName)
    return new Promise((resolve, reject) => {
      const objectStore = db.transaction(storeName).objectStore(storeName)
      const request = objectStore.get(key)
      request.addEventListener('success', () => {
        // If the result exists in the database (is not undefined).=
        if (!request.result) {
          // Fetch the videos from the network
          reject()
        } else {
          resolve(request.result)
        }
      })
    })
  }

  localDb.store = async function (storeName, key, data) {
    const db = await localDb.getDb(storeName)

    return new Promise((resolve, reject) => {
      const objectStore = db.transaction([storeName], 'readwrite').objectStore(storeName)
      // Create a record to add to the IDB
      const record = {
        data,
        id: key
      }
      const request = objectStore.add(record)

      request.addEventListener('success', () => resolve())
      request.addEventListener('error', () => reject(request.error))
    })
  }

  app.config.globalProperties.$localDb = localDb
}
